import COUNTRIES from '../countries.translations'

import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story07.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story07'
const figure = articleFigure(dir)

export const story07: Article = {
  id: 7,
  slug: 'race-for-rare-earth-materials',
  order: 7,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('ree'),
  author: 'Caleb Larson',
  // The shield is a craton, not a point, so the pin sits at its middle by Kropyvnytskyi.
  region: [
    {
      name: t.regionName,
      country: COUNTRIES.ukraine,
      coordinates: [32.26, 48.51],
      impact: 'geopolitical',
    },
  ],
  impactList: ['geopolitical'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[1]] },
      figure('02.jpg', t.captions[1]), // good image
      { type: 'prose', blocks: [...t.prose[2]] }, // China’s rare earth dominance was built over decades
      { type: 'prose', blocks: [...t.prose[3]] }, // Supply chain leverage and Ukraine
      figure('03.jpg', t.captions[2]), // need to update this image
      { type: 'prose', blocks: [...t.prose[4]] }, // Solutions to redistributing the supply chain
      { type: 'quote', ...t.quotes[1] }, // “Kyiv’s longer-term goal ...
      { type: 'prose', blocks: [...t.prose[5]] }, // Rare earths and the geopolitical connection
      figure('04.jpg', t.captions[3]), // update image
      { type: 'prose', blocks: [...t.prose[6]] }, // The path forward: Investing across the entire value chain
    ],
  },
}
